import { InteractionViewDto } from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const interactionRequests = {
  getGuideInteractions: new EndpointDefinition<
    InteractionViewDto,
    null,
    { guideId: string; startEpochTime: number; endEpochTime: number }
  >({
    name: 'getGuideInteractions',
    route: '/interaction/guide/:guideId',
    method: 'GET',
  }),
};
